var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.61905C8.57187 7.61905 10.25 5.91429 10.25 3.80952C10.25 1.70476 8.57187 0 6.5 0C4.42812 0 2.75 1.70476 2.75 3.80952C2.75 5.91429 4.42812 7.61905 6.5 7.61905ZM5.57187 9.39683C2.49375 9.39683 0 11.9302 0 15.0571C0 15.5778 0.415625 16 0.928125 16H12.0719C12.5844 16 13 15.5778 13 15.0571C13 11.9302 10.5063 9.39683 7.42812 9.39683H5.57187Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.72b308ff17bb75d55e4b8a40573d8505.svg";
export { ForwardRef as ReactComponent };